import { reportThrottled } from '#shared';

import type { SettingsOrigin, SettingViolation } from '../model';

const REPORT_THROTTLE_MS = 60_000;

export type SettingsDrift =
  | {
      direction: 'inbound';
      key: string;
      value: unknown;
      origin: SettingsOrigin;
    }
  | {
      direction: 'rejected';
      key: string;
      value: unknown;
      violations: readonly SettingViolation[];
    };

export const reportSettingsDrift = (drift: SettingsDrift): void => {
  const { direction, key } = drift;
  reportThrottled(
    `settings:drift-${direction}:${key}`,
    `Settings drift (${direction}) on ${key}`,
    {
      throttleMs: REPORT_THROTTLE_MS,
      level: 'warning',
      tags: { settingKey: key, driftDirection: direction },
      extra: { ...drift },
    },
  );
};
